import React from 'react';
import { Box } from '@mui/material';
import { styled, type CSSProperties, type DefaultTheme } from '@mui/styles';
import { useFixedHeaderClearance } from '../../../../../../hooks/useFixedHeaderClearance';

type StickyBoxProps = Pick<CSSProperties, 'zIndex' | 'top'>;

const StickyBox = styled(Box)<DefaultTheme, StickyBoxProps>(
  ({ top, zIndex, ...props }) => ({
    backgroundColor: props.theme.palette.background.default,
    position: 'sticky',
    top: top || 0,
    zIndex: zIndex || 10,
  })
);

/** Sticks under the fixed app header, at its measured height. */
export const StickyContainer = (
  props: Omit<React.ComponentProps<typeof StickyBox>, 'top'>
) => {
  const top = useFixedHeaderClearance();
  return <StickyBox {...props} top={top} />;
};
